import { render, staticRenderFns } from "./addLocation.vue?vue&type=template&id=34c4c4ef&"
import script from "./addLocation.vue?vue&type=script&lang=js&"
export * from "./addLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports